import React, { useEffect, useState } from 'react';
import { XLoginButton } from 'react-social-login-buttons';
import Styles from '../Socials.module.scss';
import { getXToken } from 'services/integrationService';
import {
  error as errorToast,
  success as successToast,
} from 'helpers/toaster.js';
import ErrorModal from 'Components/Modal/CampaignErrorModal/CampaignErrorModal';
import { useSelector } from 'react-redux';
import { getRequest } from 'helpers/axios';
import UpgradeModal from 'Containers/Modal/UpgradeModal/UpgradeModal';

const TwitterLoginComponent = ({ onLoginSuccess }) => {
  const [errorModal, setErrorModal] = useState(false);
  const [errorDetails, setErrorDetails] = useState({ message: '', link: '' });
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const { current_subscription: currentSubscription } =
    user?.subscriptions ?? {};

  const getTwitterAuthToken = async () => {
    try {
      // Check platform integration limits
      const limitResponse = await getRequest(
        'check_limits?type=platform_integration',
      );

      if (!limitResponse.data.success) {
        if (currentSubscription?.plan_name === 'Basic Plan') {
          setShowUpgradeModal(true);
          return;
        } else {
          setErrorDetails({
            message:
              limitResponse.data.message ||
              'You have reached your platform integration limit',
            link: limitResponse.data.link || '',
          });
          setErrorModal(true);
          return;
        }
      }

      // If limit check passes, proceed with Twitter auth
      let response = await getXToken();
      const oauthToken = response.data.oauth_token;
      const width = 600;
      const height = 400;
      const left = window.innerWidth / 2 - width / 2;
      const top = window.innerHeight / 2 - height / 2;
      const windowOptions = `width=${width},height=${height},top=${top},left=${left},scrollbars=yes`;
      const twitterUrl = `https://api.twitter.com/oauth/authorize?oauth_token=${oauthToken}`;
      const authWindow = window.open(twitterUrl, 'Twitter Auth', windowOptions);
    } catch (error) {
      // console.error('Error getting Twitter request token:', error);
      // setErrorDetails({
      //   message:
      //     error.response?.data?.error ||
      //     'Failed to check platform integration limits',
      //   link: '',
      // });
      // setErrorModal(true);
      setErrorDetails({
        message:
          error.response?.data?.error ||
          'You have reached your platform integration limit',
        link: 'https://appsumo.com/products/vocable-ai',
      });

      if (currentSubscription?.plan_name === 'Basic Plan') {
        setShowUpgradeModal(true);
      } else {
        setErrorModal(true);
      }
    }
  };

  const handleLinkedInSuccess = async (code) => {
    onLoginSuccess();
    successToast(`Integration Successfully added!`);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      // Guard against messages without expected structure
      if (!event.data || typeof event.data !== 'object') return;

      if (event.data.type === 'X_SUCCESS') {
        handleLinkedInSuccess();
      } else if (event.data.type === 'X_ERROR') {
        const payload = event.data.payload || {};
        if (currentSubscription?.is_appsumo && payload.showModal) {
          setErrorDetails({
            message: payload.message || 'An error occurred',
            link: payload.link || '',
          });
          setErrorModal(true);
        } else {
          errorToast(payload.message || 'An error occurred');
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [currentSubscription]);

  return (
    <>
      <div
        className={`${Styles.IntegrationBtn} rounded-4`}
        onClick={getTwitterAuthToken}
      >
        <img src={`/Images/logo-x.png`} alt={'x'} width="50" height="50" />
        <p>X</p>
      </div>

      {showUpgradeModal && (
        <UpgradeModal
          show={showUpgradeModal}
          onHide={() => setShowUpgradeModal(false)}
        />
      )}

      {errorModal && (
        <ErrorModal
          show={errorModal}
          onHide={() => setErrorModal(false)}
          errorMessage={errorDetails.message}
          errorLink={errorDetails.link}
        />
      )}
    </>
  );
};

export default TwitterLoginComponent;
